/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Door_Manual_TitleInputs */

const en_simple_door_manual_title = /** @type {(inputs: Simple_Door_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On your own`)
};

const id_simple_door_manual_title = /** @type {(inputs: Simple_Door_Manual_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandiri`)
};

/**
* | output |
* | --- |
* | "On your own" |
*
* @param {Simple_Door_Manual_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_manual_title = /** @type {((inputs?: Simple_Door_Manual_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Manual_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_manual_title(inputs)
	return en_simple_door_manual_title(inputs)
});